import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

function Title({ children, sx }) {
    return (
        <Typography
            component="h2"
            variant="h6"
            sx={sx}
        >
            {children}
        </Typography>
    )
}

Title.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
}

export default Title
